import Splide from '@splidejs/splide';

const EL = '.js-hero';

document.querySelectorAll(EL).forEach(sliderElement => {
  new Splide(sliderElement, {
    type: 'fade',
    pagination: true,
    arrows: true,
    pauseOnHover: true,
    updateOnMove: true,
    autoplay: true,
    interval: 5000,
    rewind: true,
    pauseOnFocus: false
  }).mount();
});
